import { flattenNestedSvg } from '@/utils'

import { FrameText } from './FrameText'
import { MockQr } from './MockQr'
import {
	DEFAULT_FRAME_FONT,
	FRAME_BLACK,
	FRAME_LIGHT_GREY,
	FRAME_MEDIUM_GREY,
	TRANSPARENT_COLOR,
} from './qrFramesConstants'
import { isNormalFrameMode, TQrFrameProps } from './qrFrameTypes'

export const Frame26 = (props: TQrFrameProps) => {
	const { previewMode } = props

	const qrMarkup = isNormalFrameMode(props) ? props.patternMarkup : undefined
	const frameColor = isNormalFrameMode(props) ? props.frameColor : FRAME_BLACK
	const textColor = isNormalFrameMode(props) ? props.textColor : 'white'
	const qrBackgroundColor = isNormalFrameMode(props)
		? props.patternBackgroundColor
		: FRAME_LIGHT_GREY
	const frameBackgroundColor = isNormalFrameMode(props)
		? props.frameBackgroundColor
		: TRANSPARENT_COLOR

	const getTextY = (fontSize: number) => {
		const boxTop = 67
		const boxHeight = 11
		const centerY = boxTop + boxHeight / 2
		return centerY + fontSize * 0.085
	}

	return (
		<svg viewBox="0 0 64 84" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				id="frame-background"
				d="M8 14h51v52H8z"
				fill={frameBackgroundColor}
			/>
			<path
				id="shadow"
				d="m6.238 14.453-.02-2.23 49.22-8.278c1.293-.113 2.325.85 2.343 2.136l.019 8.353z"
				fill={previewMode ? FRAME_MEDIUM_GREY : frameColor}
				opacity={previewMode ? 1 : 0.5}
			/>
			<path
				id="frame"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M60.913 77.785a2.334 2.334 0 0 1-2.325 2.344H6.218V12.223h52.37a2.334 2.334 0 0 1 2.325 2.343zm-2.325-12.89V14.568H8.544v50.329z"
				fill={frameColor}
			/>
			<path
				id="shadow_2"
				d="M10.663 20.463h-6.45c-.807 0-1.444.662-1.444 1.436v.133c0 .813.637 1.474 1.444 1.474h6.45a1.45 1.45 0 0 0 1.443-1.455v-.133a1.45 1.45 0 0 0-1.444-1.455m.001 16.121h-6.45a1.45 1.45 0 0 0-1.444 1.456v.132a1.45 1.45 0 0 0 1.444 1.455h6.45a1.45 1.45 0 0 0 1.443-1.455v-.132a1.45 1.45 0 0 0-1.444-1.456M4.213 52.706h6.45a1.45 1.45 0 0 1 1.443 1.455v.132a1.45 1.45 0 0 1-1.444 1.456h-6.45c-.806 0-1.443-.662-1.443-1.475v-.132c0-.775.637-1.436 1.444-1.436m6.45 16.121h-6.45a1.45 1.45 0 0 0-1.444 1.455v.133a1.45 1.45 0 0 0 1.444 1.455h6.45a1.45 1.45 0 0 0 1.443-1.455v-.133a1.45 1.45 0 0 0-1.444-1.455"
				fill={previewMode ? FRAME_MEDIUM_GREY : frameColor}
			/>
			{!previewMode ? (
				<path
					id="shadow_2"
					d="M10.663 20.463h-6.45c-.807 0-1.444.662-1.444 1.436v.133c0 .813.637 1.474 1.444 1.474h6.45a1.45 1.45 0 0 0 1.443-1.455v-.133a1.45 1.45 0 0 0-1.444-1.455m.001 16.121h-6.45a1.45 1.45 0 0 0-1.444 1.456v.132a1.45 1.45 0 0 0 1.444 1.455h6.45a1.45 1.45 0 0 0 1.443-1.455v-.132a1.45 1.45 0 0 0-1.444-1.456M4.213 52.706h6.45a1.45 1.45 0 0 1 1.443 1.455v.132a1.45 1.45 0 0 1-1.444 1.456h-6.45c-.806 0-1.443-.662-1.443-1.475v-.132c0-.775.637-1.436 1.444-1.436m6.45 16.121h-6.45a1.45 1.45 0 0 0-1.444 1.455v.133a1.45 1.45 0 0 0 1.444 1.455h6.45a1.45 1.45 0 0 0 1.443-1.455v-.133a1.45 1.45 0 0 0-1.444-1.455"
					fill="white"
					opacity={0.5}
				/>
			) : null}
			<rect
				id="qr-background"
				x={13.5}
				y={18.5}
				width={42}
				height={42}
				rx={2}
				fill={qrBackgroundColor}
			/>
			{qrMarkup ? (
				<g
					dangerouslySetInnerHTML={{
						__html: flattenNestedSvg(qrMarkup, {
							x: 19.5,
							y: 24.5,
							width: 30,
							height: 30,
						}),
					}}
				/>
			) : (
				<MockQr x={19.5} y={24.5} width={30} height={30} />
			)}
			<FrameText
				text={props.text}
				fontSize={props.fontSize}
				textColor={textColor}
				textY={getTextY(props.fontSize)}
				xOffset={2}
				fontFamily={DEFAULT_FRAME_FONT}
			/>
		</svg>
	)
}
